import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../config";
import axiosClient from "../../common/api/request";

export const getNotifications = createAsyncThunk(
  "notifications/getAll",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/notifications/`,
        { params },
        config
      );
      return { ...data, page: params.page || 1 };
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue({ ...error.response.data, status: error.response.status });
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const markNotificationRead = createAsyncThunk(
  "notifications/markRead",
  async ({ id, is_read }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.patch(
        `${config.API_URL}/notifications/${id}/`,
        { is_read },
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue({ ...error.response.data, status: error.response.status });
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);

export const markAllNotificationsRead = createAsyncThunk(
  "notifications/markAllRead",
  async (_, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/notifications/mark-all-read/`,
        {},
        config
      );
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "object"
      ) {
        return rejectWithValue({ ...error.response.data, status: error.response.status });
      } else {
        return rejectWithValue({
          Error: error.message,
        });
      }
    }
  }
);
